module.exports = __webpack_public_path__ + "static/media/ico_endpoint_o.53166d8e.svg";